import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { Select } from "Components/Form/Select";
import { getError } from "Utils/productUtils";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import { FormikProps } from "formik";
import React from "react";
import { ChildDatesOfBirthFormElements } from "./ChildDatesOfBirthFormElements";
import { getFamilySituationOptions } from "./formElementsOptions";
import { AdviceProductDetailsFormValues } from "./interfaces";
import { FormGroupWrap } from "./styled";

interface Props {
  formProps: FormikProps<AdviceProductDetailsFormValues>;
  formText: any;
  lang: string;
}
export const FamilyFormElements = ({
  formProps,
  formText,
  lang,
}: Props): React.ReactElement => {
  const aboutYou = formText.aboutYou;
  const isExpectingChildrenToggle = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_827_IS_EXPECTING_CHILDREN,
  );

  return (
    <FormGroupWrap>
      <Select
        large
        id="familySituation"
        name="familySituation"
        label={aboutYou.familySituation.label[lang]}
        hint={aboutYou.familySituation.hint[lang]}
        options={getFamilySituationOptions(
          aboutYou.familySituation.options,
          lang,
        )}
        error={getError("familySituation", formProps)}
      />
      <ChildDatesOfBirthFormElements
        formProps={formProps}
        formText={formText}
        lang={lang}
      />
      {isExpectingChildrenToggle && (
        <RadioButtonTrueFalse
          name="isExpectingChildren"
          id="isExpectingChildren"
          label={"Venter dere barn?"}
          direction="vertical"
          error={getError("isExpectingChildren", formProps)}
        />
      )}
    </FormGroupWrap>
  );
};
